module.exports = __webpack_public_path__ + "static/media/profileIcon.3528d210.svg";